var map = {
	"./1_establish_keep.mp4": "./src/video/1_establish_keep.mp4",
	"./3_construct_strategic_defense.mp4": "./src/video/3_construct_strategic_defense.mp4",
	"./5_recruit_wizards.mp4": "./src/video/5_recruit_wizards.mp4",
	"./trailer_combat_simple.mp4": "./src/video/trailer_combat_simple.mp4",
	"./trailer_combat_simple.webm": "./src/video/trailer_combat_simple.webm"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/video lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;